export function readStorage<T>(
  key: string,
  fallback: T,
  storage: 'local' | 'session' = 'local',
): T {
  try {
    const raw = (storage === 'local' ? localStorage : sessionStorage).getItem(key)
    return raw === null ? fallback : (JSON.parse(raw) as T)
  } catch {
    return fallback
  }
}

export function writeStorage(key: string, value: unknown, storage: 'local' | 'session' = 'local') {
  try {
    ;(storage === 'local' ? localStorage : sessionStorage).setItem(key, JSON.stringify(value))
  } catch {
    return
  }
}
